import { styled } from "@monolith-forensics/monolith-ui";

export const FileList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

// Same look as the rows in ValidationDocumentsField, but a button: clicking
// a row opens the file in the viewer. Shared by ValidationReports (ENG-1673)
// and AssetAttachmentsSection (ENG-1671).
export const FileRow = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  border: 1px solid ${({ theme }) => theme.palette.divider};
  border-radius: 6px;
  background: none;
  color: inherit;
  font: inherit;
  font-size: 12px;
  text-align: left;
  width: 100%;
  cursor: pointer;

  &:hover:not(:disabled),
  &:focus-visible {
    border-color: ${({ theme }) => theme.palette.primary.main};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  .file-name {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .file-meta {
    color: ${({ theme }) => theme.palette.text.secondary};
    white-space: nowrap;
  }
`;
